import { Expose, Type } from 'class-transformer';
import { Media } from '../../shared-features/models/media.model';
import { Fleet } from './fleet.model';
import { User } from '../../users/models/user.model';
import { LicenseType, Nationality } from '../../shared-features/enums/fleets.enum';
import { DropdownModel } from '@shared/models/dropdown-model.model';

export class TruckDriverModel extends DropdownModel {
  @Expose() id: number;
  @Type(() => User)
  @Expose() user: User = new User();
  @Type(() => Fleet)
  @Expose() fleet: Fleet = new Fleet();
  @Expose() name: string;
  @Expose() iqamaId: string;
  @Expose() nationality: Nationality;
  @Expose() licenseType: LicenseType;
  @Type(() => Media)
  @Expose() licenseAttachment: Media = new Media();
  @Expose() title: string;
  @Expose() email: string;
  @Expose() mobileNumber: string;
  @Expose() code: number;
  @Expose() firstName = '';
  @Expose() lastName = '';
  @Type(() => Media)
  @Expose() logo: Media = new Media();
  @Expose() createdAt: number;
  @Expose() updatedAt: number;

  constructor() {
    super();
  }

  get fullName(): string {
    return this.user?.firstName + ' ' + this.user?.lastName;
  }

  get dropDownDisplayName(): string {
    return this.user?.firstName + ' ' + this.user?.lastName;
  }

  get dropDownValue(): object {
    return this;
  }
}
